import { useState } from 'react';
import { useAuth } from '../../../../context/authContext';
import { Box, Tabs, Tab, Typography } from '@mui/material';
import RetailerSkillingSheet from './retailerSkillSheet/retailerSkillSheet';
import SpecialtySkillingSheet from './specialtySkillSheet/specialtySkillSheet';
import EsAuroraSkillingSheet from './esAuroraSkillSheet/esAuroraSkillSheet';

export default function SkillingSheetPage() {
  const [value, setValue] = useState(0);
  const { user } = useAuth();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          backgroundColor: 'var(--reach-blue)',
          height: '35px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'left',
        }}
      >
        <Typography
          sx={{
            fontFamily: 'BrightstarSans-Bold',
            color: 'var(--dust-white)',
            ml: 2,
          }}
        >
          {'Admin Panel - Skilling Sheet'}
        </Typography>
      </Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label='basic tabs example'
        >
          <Tab label='Retailer' />
          <Tab label='Specialty' />
          <Tab label='ES/Aurora' />
        </Tabs>
      </Box>
      {value === 0 && <RetailerSkillingSheet user={user} />}
      {value === 1 && <SpecialtySkillingSheet user={user} />}
      {value === 2 && <EsAuroraSkillingSheet user={user} />}
    </Box>
  );
}
